import { render, staticRenderFns } from "./BottomUpRegister.vue?vue&type=template&id=c266d6a4&scoped=true&"
import script from "./BottomUpRegister.vue?vue&type=script&lang=js&"
export * from "./BottomUpRegister.vue?vue&type=script&lang=js&"
import style0 from "./BottomUpRegister.vue?vue&type=style&index=0&id=c266d6a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c266d6a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
